import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let EInsuranceVerificationSchedulerStatus;
(function (EInsuranceVerificationSchedulerStatus) {
  EInsuranceVerificationSchedulerStatus["Scheduled"] = "scheduled";
  EInsuranceVerificationSchedulerStatus["Pending"] = "pending";
  EInsuranceVerificationSchedulerStatus["Validated"] = "validated";
  EInsuranceVerificationSchedulerStatus["Skipped"] = "skipped";
  EInsuranceVerificationSchedulerStatus["Failed"] = "failed";
})(EInsuranceVerificationSchedulerStatus || (EInsuranceVerificationSchedulerStatus = {}));
export const fieldsInsuranceVerificationScheduler = _extends({}, fieldsIBaseModel, {
  appointment: {
    type: 'ID',
    ref: EModel.Appointment
  },
  appointmentType: {
    type: 'ID',
    ref: EModel.AppointmentType
  },
  insuranceStatus: {
    type: 'Object',
    array: true
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  status: {
    type: 'Option',
    values: EInsuranceVerificationSchedulerStatus
  },
  validateAt: {
    type: 'Date'
  },
  validatedAt: {
    type: 'Date'
  }
});